export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={`bg-background border-border rounded-md border ${className ?? ''}`}>
    {children}
  </div>
);

export const Header = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={`border-border border-b p-2 ${className ?? ''}`}>
    {children}
  </div>
);

export const Body = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={`h-[25vh] overflow-auto p-2 ${className ?? ''}`}>
    {children}
  </div>
);

export const Footer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={`border-border border-t p-2 ${className ?? ''}`}>
    {children}
  </div>
);
